import React, { FC } from 'react';
import { Grid, Box, Button } from '@mui/material';
import StyledBox from 'views/rebranded-module/common/components/UI/EagleSharePromoV2/EagleSharePromoV2.styles';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import { Typography700, ImgBox } from 'views/common/components';
import NavigatorLink from 'views/rebranded-module/common/components/Logical/NavigatorLink';
import useAdabtiveMultiSizeImage from 'views/common/hooks/useAdabtiveMultiSizeImage';

const EagleSharePromoV2:FC<any> = (props) => {
  const { path } = props;
  const cmsData = useContent('EagleSharePromoComponent');
  const getSizedImage = useAdabtiveMultiSizeImage();
  return (
    <StyledBox>
      <NavigatorLink {...(path ? { href: path } : {})}>
     <Box className="ESPHeaderContainer">
      <Typography700 variant='h4' component="h2">
        {cmsData.title }
      </Typography700>
      <Button variant='contained' color='primary' className='ESPSeeMoreBtn'>
           {cmsData.buttonLabel}
      </Button>
     </Box>
     <Grid container spacing={2} > 
      {cmsData.esBikes.map((bike:any) => (
        <Grid item xl={3} lg={4} md={4} sm={6} key={bike.id} className='ESPGridCard' >
          <Box>
            <Box className="ESPImgContainer">
            <ImgBox
             image={{
              src: getSizedImage(bike.image.sizes),
                alt: bike.image.alt,
            }}
             imgHeight="100%"
             imhWidth="100%"
            />
            </Box>
              <Typography700
                variant="overline2"
                component="h4"
                color="text.secondary">
                {bike.title}
              </Typography700>
              <Typography700
                variant="h7"
                component="h3"
                mb={1.5}
                >
                {bike.subTitle}
              </Typography700>
          </Box>
         </Grid>
      ))}
      </Grid>
      </NavigatorLink>
    </StyledBox>
  );
};

export { EagleSharePromoV2 };